<h1
    class="page-title"
    style="margin: 0 !important;"
    ngClass.xs="page-title-mobile"
>
    {{ listingTitleData?.text }}
</h1>
